import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { push } from "connected-react-router";

import { TYPES } from "utils/constants";

import SocialModal from "social/SocialModal";
import EditSocialModal from "social/EditSocialModal";

import VideoSpecsModal from "widgets/modals/creatives/VideoSpecsModal";

import CreativePreviewBlade from "widgets/modals/creatives/preview/CreativePreviewBlade";
import PreviewBlade from "widgets/modals/creatives/social/PreviewBlade";
import NoIntegrationsModal from "widgets/modals/creatives/social/NoIntegrationsModal";
import LibraryPropertiesModal from "widgets/LibraryPropertiesModal";
import ShareLibraryModal from "widgets/ShareLibraryModal";
import CreateVASTModal from 'widgets/modals/creatives/vast/CreateVAST';
import CreateAudioModal from 'widgets/modals/creatives/vast/CreateAudio';
import CreateDisplayConceptModal from 'widgets/modals/creatives/CreateDisplayConceptModal';
import CreateNativeAdModal from 'widgets/modals/creatives/CreateNativeAdModal';
import ImportPreviewBlade  from "widgets/modals/versions/ImportPreviewBlade";
import AudioSpecsModal from "widgets/modals/creatives/AudioSpecsModal";
import EditCreativeTagModal from "widgets/modals/creatives/EditCreativeTagModal";
import AIGenerateVersionsBlade from "widgets/modals/creatives/GenerateVersionsAI/AIGenerateVersionsBlade";


export default function Modals({ returnPath, libraryId }){
	const dispatch = useDispatch();
	let { path, url } = useRouteMatch();

	function onCloseModal(){
		dispatch(push(`${url}/`));
	}
	const currentLib = useSelector(state => state.libraryProperties);
	const socialState = useSelector(state => state.social);

	return (
		<Switch>
			<Route
				exact
				path   = {`/library/:libraryId/modal/video-specs/:videoId/`}
				render = {(routeRenderProps) => {
					let { videoId } = routeRenderProps.match.params;
					return (
						<VideoSpecsModal
							type={TYPES.CREATIVES}
							libraryId = {parseInt(libraryId)}
							videoId = {parseInt(videoId)}
							returnPath = {returnPath}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/audio-specs/:audioId/`}
				render = {(routeRenderProps) => {
					let { audioId } = routeRenderProps.match.params;
					return (
						<AudioSpecsModal
							type={TYPES.CREATIVES}
							libraryId = {parseInt(libraryId)}
							audioId = {parseInt(audioId)}
							returnPath = {returnPath}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/create-concept/social/`}
				render={() => {
					return (
						<SocialModal
							returnPath={returnPath}
							libraryId={libraryId}
							socialState={socialState}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/add-to-concept/social/:conceptId/`}
				render = {(routeRenderProps) => {
					let { conceptId } = routeRenderProps.match.params;
					return (
						<SocialModal
							libraryId = {libraryId}
							conceptId = {conceptId}
							socialState={socialState}
							returnPath = {returnPath}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/preview-creative/:type/:creativeId/`}
				render = {(routeRenderProps) => {
					let { creativeId, type } = routeRenderProps.match.params;
					let modalProps = {
						libraryId,
						creativeId,
						returnPath,
					};
					if(/social/gi.test(type)){
						return <PreviewBlade {...modalProps} />;
					}
					return (
						<CreativePreviewBlade {...modalProps} />
					);
				}}
			/>
			{/* <Route
				exact
				path   = {`/library/:libraryId/modal/preview-creative/social/:creativeId/`}
				render = {(routeRenderProps) => {
					let { creativeId } = routeRenderProps.match.params;
					return (
						<PreviewBlade
							libraryId = {libraryId}
							creativeId = {creativeId}
							returnPath = {returnPath}
						/>
					);
				}}
			/> */}
			<Route
				exact
				path   = {`/library/:libraryId/modal/no-integration/`}
				render = {(routeRenderProps) => {
					return (
						<NoIntegrationsModal
							libraryId = {libraryId}
							returnPath = {returnPath}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/edit/`}
				render = {() => (
					<LibraryPropertiesModal
						libraryId = {libraryId}
						returnPath = {returnPath}
					/>
				)}
			/>
			<Route
				exact
				path   = {`/library/:libraryId/modal/share/`}
				render = {() => (
					<ShareLibraryModal
						libraryId = {libraryId}
						returnPath = {returnPath}
						name={currentLib.name}
					/>
				)}
			/>
			<Route
				exact
				path={`/library/:libraryId/modal/create-vast/`}
				render={() => (
					<CreateVASTModal
						libraryId = {libraryId}
						returnPath = {returnPath}
						isMultiple = {true}
					/>
				)}
			/>
			<Route
				exact
				path={`/library/:libraryId/modal/create-audio/`}
				render={() => (
					<CreateAudioModal
						libraryId={libraryId}
						returnPath={returnPath}
						isMultiple
					/>
				)}
			/>
			<Route
				exact
				path={`/library/:libraryId/modal/replace-vast/:creativeId/`}
				render= {(routeRenderProps) => {
					let { creativeId } = routeRenderProps.match.params;
					return(<CreateVASTModal
						libraryId = {libraryId}
						creativeId = {creativeId}
						returnPath = {returnPath}
						isMultiple = {false}
					/>
					);
				}}
			/>
			<Route
				exact
				path={`/library/:libraryId/modal/replace-vast-audio/:creativeId/`}
				render= {(routeRenderProps) => {
					let { creativeId } = routeRenderProps.match.params;
					return (
						<CreateAudioModal
							libraryId = {libraryId}
							creativeId = {creativeId}
							returnPath = {returnPath}
							isMultiple = {false}
						/>
					);
				}}
			/>
			<Route
				exact
				path={'/library/:libraryId/modal/create-concept/open/'}
				render={() => {
					return(
						<CreateDisplayConceptModal
							returnPath={returnPath}
							libraryId={libraryId}
						/>
					);
				}}
			/>
			<Route
				exact
				path="/library/:libraryId/modal/edit-creative/social/:creativeId/"
				render={(routeRenderProps) => {
					let { creativeId } = routeRenderProps.match.params;

					return (
						<EditSocialModal
							returnPath={returnPath}
							libraryId={libraryId}
							creativeId={creativeId}
							socialState={socialState}
						/>
					);
				}}
			/>
			<Route
				exact
				path={'/library/:libraryId/modal/create-native-ad/'}
				render={() => {
					return(
						<CreateNativeAdModal
							returnPath={returnPath}
							libraryId={libraryId}
						/>
					);
				}}
			/>
			<Route
				exact
				path="/library/:libraryId/modal/edit-concept/display-tag/:creativeId/"
				render={(routeRenderProps) => {
					let { creativeId } = routeRenderProps.match.params;

					return (
						<EditCreativeTagModal
							returnPath={returnPath}
							creativeId={creativeId}
							libraryId={libraryId}
						/>
					);
				}}
			/>
			<Route
				exact
				path   = {`${path}modal/preview-version-import/:jobId/`}
				render = {(routeRenderProps) => {
					let { jobId } = routeRenderProps.match.params;
					return (
						<ImportPreviewBlade
							jobId = {jobId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path = {`${path}concept/:conceptId/generate-versions`}
				render = {(routeRenderProps) => {
					const { conceptId } = routeRenderProps?.match?.params || {};
					return (
						<AIGenerateVersionsBlade
							returnPath = {returnPath}
							libraryId = {libraryId}
							conceptId = {conceptId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
			<Route
				exact
				path = {`${path}creatives/generate-versions`}
				render = {(routeRenderProps) => {
					return (
						<AIGenerateVersionsBlade
							returnPath = {returnPath}
							libraryId = {libraryId}
							onClose = {onCloseModal}
						/>
					);
				}}
			/>
		</Switch>
	);
}

Modals.displayName = "CreativesModals";
